var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 62,
    viewBox: "0 0 55 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_57_1933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.5095 31.5433C41.5469 31.2478 41.5138 30.9661 41.4141 30.7318C41.3143 30.4975 41.1521 30.3203 40.9466 30.2212L40.9415 30.2187L31.6136 25.7321L31.5983 25.6209L38.8092 14.1458C38.9997 13.8436 39.1151 13.4965 39.1373 13.1587C39.1596 12.8209 39.0875 12.5112 38.9323 12.2779C38.8351 12.1293 38.7082 12.0141 38.5593 11.9394C38.3987 11.8615 38.2161 11.8339 38.0251 11.8585C37.8341 11.8831 37.6396 11.9594 37.456 12.0816L15.6596 26.4707C15.427 26.624 15.2198 26.845 15.062 27.1082C14.9042 27.3714 14.8021 27.6661 14.7675 27.9583C14.733 28.2505 14.7674 28.5284 14.8668 28.7597C14.9661 28.991 15.1265 29.1665 15.3292 29.2658L23.7079 33.3734L23.7146 33.4891L14.6914 46.4622C14.4847 46.7588 14.3516 47.108 14.3133 47.4542C14.2751 47.8004 14.3338 48.1236 14.4803 48.3725C14.6267 48.6213 14.8524 48.7814 15.1213 48.8272C15.3903 48.8731 15.6871 48.802 15.9644 48.6253L40.5923 33.0391C40.8299 32.8895 41.0426 32.6689 41.2052 32.4037C41.3678 32.1385 41.4735 31.8399 41.5095 31.5433Z",
    fill: "#DC6200"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_1933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4375,
    height: 49.6875,
    fill: "white",
    transform: "translate(22.2026 0.462402) rotate(26.1164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.a7a7e1e368a7a63e9a26bfc36a7f0415.svg";
export { ForwardRef as ReactComponent };